module.exports = __webpack_public_path__ + "img/arrow-red.daef059b.svg";